module.exports = __webpack_public_path__ + "img/mexican.c40f225e.png";